module.exports = __webpack_public_path__ + "static/index/img/banner_background.625f1e87.png";